<template>
    <!-- 案例 - 详情 -->
    <div>
        <myheader :messages="parentMessage"></myheader>
        <!--  -->
        <div class="aboutopcomm aboutopcomm4 w1750 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="mk wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                <div class="h">{{goolist.title}}</div>
                <div class="p">{{goolist.brief}}</div>
                <div class="moreboxmax">
                    <div class="a a1">访问</div> 
                      <div class="a a2" @click="kefuclick">想要做类似的？</div>
                </div>
            </div>
        </div>
        <div class="caseboxdatawer wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
            <div class="icon">
                <div class="h">标签</div>
                <div class="mm">
                   <i v-for="item in goolist.tags">{{item}}</i>
                </div>
            </div>
            <div class="img" v-html="goolist.content">
                
            </div>
            <div class="boot">
                <img src="../assets/img/icon33.png" alt="" />
            </div>
        </div>
        <!--   -->
        <myfooter></myfooter>
    </div>
</template>

<script>
    import myfooter from './footer.vue'
    import myheader from './header.vue'
    
    export default {
        data() {
            return {
               parentMessage: 2,
               goolist: [],
               //id: ''
            }
        },
        created() {
            /* this.title = this.$route.query.title
            this.brief = this.$route.query.brief */
            //this.id = this.$route.query.id
            //console.log(this.id)
            this.gooler(this.$route.query.id);
        },
        methods: {
            // 获取商品详情的方法
            async gooler(id) {
                //var url = `case/list?id=${id}`
                var url = `/api/case/${id}`
                const { data: res } = await this.$http.post(url)
                
                this.goolist = res.data
            },
            kefuclick(){
                const url = 'https://p.qiao.baidu.com/cps4/chatIndex?siteToken=fa6b3d5361002f77431328216553694d&speedLogId=16216501944184228_1621650194418_93941&eid=25401671&reqParam=%7B%22from%22%3A0%2C%22sid%22%3A%22-100%22%2C%22tid%22%3A%22-1%22%2C%22ttype%22%3A1%2C%22siteId%22%3A%2211856238%22%2C%22userId%22%3A%2225401671%22%2C%22pageId%22%3A0%7D';
                // window.location.href = url;
                window.open(url)
            }
        },
        components: {
        	myfooter, myheader
        }
    }
</script>

<style>

</style>